import { Button, Card, Header, MessageText, SubjectText } from './message-card.styled';
import { useDispatch, useSelector } from 'react-redux';

import { CheckInSummaryState } from '../../../../redux/reducers/checkInSummarySlice';
import { MessageCardProps } from '../../../../models/notification-model';
import React from 'react';
import { RootState } from '../../../../config/redux/store';
import { acknowledgeMessageAsync } from '../../../../redux/reducers/notificationSlice';
import { getDeviceToken } from '../../../../services/token.service';
import { getMessageContent } from '../../../../utils/messageHelpers';

const MessageCardComponent: React.FC<MessageCardProps> = ({
  messageId,
  store,
  date,
  message,
  subject,
  purposeName,
  acknowledged
}) => {
  const dispatch = useDispatch();

  // Get check-in summary for isCheckedIn validation
  const { checkInSummary } = useSelector<RootState, CheckInSummaryState>(
    (state) => state.globalVendorCheckIn.checkInSummary
  );
  const { checkIns } = checkInSummary;

  const handleAcknowledge = () => {
    if (!acknowledged) {
      const mostRecentCheckin = checkIns && checkIns.length > 0 ? checkIns[0] : null;
      const vendorUserId = mostRecentCheckin?.vendorUser?.vendorUserId;

      if (vendorUserId) {
        getDeviceToken().then((deviceToken) => {
          if (deviceToken) {
            // Make API call to acknowledge the message

            dispatch(
              acknowledgeMessageAsync({
                messageId,
                vendorAckBy: vendorUserId,
                deviceToken: deviceToken
              })
            );
          }
        });
      }
    }
  };
  return (
    <Card>
      <Header>
        <span>Store: {store}</span>
        <span>{date}</span>
      </Header>
      <SubjectText>{subject}</SubjectText>
      <MessageText>
        <span>Message:</span>{' '}
        <span
          dangerouslySetInnerHTML={{
            __html: getMessageContent(message) || 'No content available'
          }}
        />
      </MessageText>
      <MessageText>
        <span>Purpose:</span> {purposeName}
      </MessageText>
      <Button acknowledged={acknowledged} disabled={acknowledged} onClick={handleAcknowledge}>
        {acknowledged ? 'acknowledged' : 'acknowledge'}
      </Button>
    </Card>
  );
};

export default MessageCardComponent;
